// Why a Gargi action (draft, launch, audience, assign) didn't go through, in words a person can act on.
export const actionError = (error: unknown, fallback = 'That didn’t go through. Try again in a moment.'): string => {
  const response = (error as { response?: { status?: number; data?: { message?: string } } })?.response;
  const message = response?.data?.message ?? '';
  if (/permission denied/i.test(message)) {
    return 'This preview is read-only, so nothing can be saved here. Use it on QA or in production to create drafts and audiences.';
  }
  if (message) return message;
  if (response?.status === 404) return 'This Gargi play isn’t set up in this environment yet.';
  return fallback;
};
